import { Heading, Paragraph } from '../../components';
import { numberToPercent } from '../../utils/translate';
import { useTranslation } from 'react-i18next';
import styles from './DiscountTag.module.scss';

interface DiscountTagProps {
  discountPercent: number;
  maxTerm?: number;
  testIdPrefix: string;
}

export const DiscountTag = ({
  discountPercent,
  maxTerm,
  testIdPrefix,
}: DiscountTagProps) => {
  const { t } = useTranslation('discount');

  return (
    <div
      className={styles['discount-notification']}
      data-test={`${testIdPrefix}-discount-notif`}
    >
      <div
        className={styles['discount-bg']}
        data-test={`${testIdPrefix}-discount-notif-percent`}
      >
        {numberToPercent(-discountPercent)}
      </div>
      <div className={styles['text-containers']}>
        <Heading dataTest={`${testIdPrefix}-discount-notif-header`}>
          {t('extension_header')}
        </Heading>
        <Paragraph
          className={styles['discount-validity']}
          dataTest={`${testIdPrefix}-discount-notif-validity`}
        >
          {maxTerm && t('validity_extension', { term: maxTerm })}
        </Paragraph>
      </div>
    </div>
  );
};
